export default __webpack_public_path__ + "static/media/calendar.85477201.svg";